import RegisterForm from "../components/RegisterForm";

const RegisterRequestPage = () => {
    return (
        <div>
       <RegisterForm />
        </div>
    );
}
export default RegisterRequestPage;  // ✅ Export the component